import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {isInMwEditDesignABTest} from '~/common/fabric/experiments';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';

export const useInMwEditDesignButtonAbTest = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const currentRoute = useCurrentRoute();
  const isStep1 = currentRoute?.name === 'customize' && currentRoute?.meta?.editing === false;

  if (!isLargishAndUp && !isStep1) {
    return isInMwEditDesignABTest();
  }
  return false;
};
